// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { getWorkshopNotes } from '../../../apis/workshop';
import { parseCamelCase } from '../../../apis/util';
import { RootAction, actionCreatorsList } from '../../rootActionCreator';
const { getWorkshopNotesDataActions } = actionCreatorsList;

const outputActions = {
  success: getWorkshopNotesDataActions.success,
  failure: getWorkshopNotesDataActions.failure
};

type RequestActionTypes = ActionType<
  typeof getWorkshopNotesDataActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

const getWorkshopNotesDataEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(getWorkshopNotesDataActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id } = action.payload;
      // send api promise
      return getWorkshopNotes(id)
        .then(response => {
          const notes = response.data.message.notes;
          const parsedNotes = parseCamelCase(notes).map((note:any) => ({
            ...note,
            message: note.note,
            note: undefined
          }));
          // handle success case here
          return getWorkshopNotesDataActions.success({
            id,
            notes: parsedNotes
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          console.log(error)
          return getWorkshopNotesDataActions.failure({ error });
        });
    })
  );
};

export { getWorkshopNotesDataEpic as default};
